// extracted by mini-css-extract-plugin
export var container = "_4m-0";
export var infoButton = "_4m-1";
export var label = "_4m-3";
export var labelExpanded = "_4m-4";
export var price = "_4m-5";
export var priceExpanded = "_4m-6";
export var title = "_4m-2";